import { Card, Timeline, Typography } from 'antd';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';

export interface GeneralRequestJobPostingTimelineProps {
  action: 'REQUEST_CREATED' | 'REQUEST_CANCELED' | 'STAGE_APPROVED' | 'STAGE_REJECTED';
  stage?: string;
  userName: string;
  commentary?: string;
  createdDate: string;
  timelineIcon: React.ReactNode;
}

const GeneralRequestJobPostingTimeline = ({
  action,
  stage,
  userName,
  commentary,
  createdDate,
  timelineIcon,
}: GeneralRequestJobPostingTimelineProps) => {
  const { t } = useTranslation();

  let actionText = '';

  switch (action) {
    case 'REQUEST_CREATED':
      actionText = t('iniciou');
      break;
    case 'REQUEST_CANCELED':
      actionText = t('cancelou');
      break;
    case 'STAGE_APPROVED':
      actionText = t('aprovou');
      break;
    case 'STAGE_REJECTED':
      actionText = t('reprovou');
      break;
  }

  return (
    <Timeline.Item dot={timelineIcon}>
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
          <br />
          <Typography.Text>
            <Typography.Text strong>{userName} </Typography.Text>
            {actionText}{' '}
            {stage ? (
              <>
                <Trans>a etapa</Trans> {stage} <Trans>da requisição</Trans>
              </>
            ) : (
              <>
                <Trans>a requisição</Trans>
              </>
            )}
          </Typography.Text>
          {!!commentary && (
            <Typography.Text>
              {' '}
              <Trans>com o comentário</Trans>:
              <br />
              {commentary}
            </Typography.Text>
          )}
        </Typography.Paragraph>
      </Card>
    </Timeline.Item>
  );
};

export default GeneralRequestJobPostingTimeline;
